import { cx } from "@linaria/core";
import { useMemo } from "react";

import { textComponentHtmlParsers } from "@pm2/content-engine";
import {
  containerCls,
  headingsCls,
  spacingCls,
  textComponentChildPrinters,
} from "@pm2/text-component";
import { ReliefSVG } from "@pm2/ui-layout";
import { breakpoints } from "@ui/css";
import { printAST, xml2ast } from "@utils/ast";
import { HideFor, PostloadedImage, ShowFor } from "@utils/react";

import * as styles from "./page.content.frontpage-topsection.style";

type Props = {
  label: string;
  heading: string;
  description: string;

  image: {
    src: string;
    width?: number;
    height?: number;
  };
};

export function FrontpageTopsection(props: Props) {
  const content = useMemo(
    () =>
      printAST(
        xml2ast(props.description, textComponentHtmlParsers, "text/html"),
        textComponentChildPrinters,
      ),
    [props.description],
  );

  return (
    <section className={styles.section} data-frontpage-top-section>
      <div className={styles.content}>
        <div className={styles.label}>{props.label}</div>
        <h1 className={styles.heading}>{props.heading}</h1>

        <HideFor breakpoint={breakpoints.mobile}>
          <p className={cx(styles.body, containerCls, spacingCls, headingsCls)}>
            {content}
          </p>
        </HideFor>
      </div>

      <PostloadedImage
        className={styles.image}
        src={props.image.src}
        sizes="(max-width: 768px) 100vw, 550px"
        width={props.image.width}
        height={props.image.height}
        alt=""
      />

      <PostloadedImage
        role="presentation"
        className={styles.backdrop}
        src={props.image.src}
        sizes="100vw"
        alt=""
      />

      <ShowFor breakpoint={breakpoints.mobile} className={styles.mobileContent}>
        <p className={cx(styles.body, containerCls, spacingCls, headingsCls)}>
          {content}
        </p>
      </ShowFor>

      <ReliefSVG position="top" className={styles.graphic} />
    </section>
  );
}
